import { render, staticRenderFns } from "./clientBasket.vue?vue&type=template&id=1781a985&scoped=true"
import script from "./clientBasket.vue?vue&type=script&lang=js"
export * from "./clientBasket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1781a985",
  null
  
)

export default component.exports